import React, {Component} from "react";
import Form from "./PromoCodeForm";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {reset} from "redux-form/immutable"
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {Map} from "immutable";

class PromoCodeFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("orderId", this.props.orderId);
    if (values.get("promoCode", "") === "") return;

    return this.props.applyPromoCodeToCheckout(updatedValues.toJS())
      .then((response) => {
        if (response.data.applyPromoCodeToCheckout.errors.length <= 0) {
          this.props.dispatch(reset("PromoCodeForm"));
          this.setState({errors: []});          
        } else {
          let errors = createValidationErrors(response.data.applyPromoCodeToCheckout.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  render() {
    let initialValues = Map();
    //   tagRules: ""
    // })
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        />
    )
  }

}

const APPLY_CHECKOUT_DISCOUNT = gql`
  mutation applyPromoCodeToCheckout($data: CheckoutPromoCodeInput!) {
    applyPromoCodeToCheckout(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(APPLY_CHECKOUT_DISCOUNT, {
    props: ({ mutate }) => ({
      applyPromoCodeToCheckout: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect()(withQueries(PromoCodeFormContainer));